import classNames from 'classnames';
import React from 'react';
import FormCheck from './FormCheck';
import FormFile from './FormFile';
import FormControl from './FormControl';
import FormGroup from './FormGroup';
import FormLabel from './FormLabel';
import FormText from './FormText';
import Switch from './Switch';
import { useBootstrapPrefix } from './ThemeProvider';
import createWithBsPrefix from './createWithBsPrefix';
import { jsx as _jsx } from "react/jsx-runtime";
const FormRow = createWithBsPrefix('form-row');
const defaultProps = {
  inline: false
};
const FormImpl = /*#__PURE__*/React.forwardRef(({
  bsPrefix,
  inline,
  className,
  validated,
  // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
  as: Component = 'form',
  ...props
}, ref) => {
  bsPrefix = useBootstrapPrefix(bsPrefix, 'form');
  return /*#__PURE__*/_jsx(Component, { ...props,
    ref: ref,
    className: classNames(className, validated && 'was-validated', inline && `${bsPrefix}-inline`)
  });
});
FormImpl.displayName = 'Form';
FormImpl.defaultProps = defaultProps;
FormImpl.Row = FormRow;
FormImpl.Group = FormGroup;
FormImpl.Control = FormControl;
FormImpl.Check = FormCheck;
FormImpl.File = FormFile;
FormImpl.Switch = Switch;
FormImpl.Label = FormLabel;
FormImpl.Text = FormText;
export default FormImpl;